import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from 'js-cookie';

import '../css/form.css'

import { UserContext } from '../context/userContext';
import Modal from "../components/Modal.js";

const serverURL = process.env.REACT_APP_BACKEND_URL;

function LogInPage() {
    const userContext = useContext(UserContext);
    const nav = useNavigate();
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [error, setError] = useState();
    const [modInfo, setModInfo] = useState([null, null]);

    // Submit Login
    async function onSubmit(e) {
        e.preventDefault();

        if (email === '') {
            setError('Error: Email is empty!');
            return;
        }
        if (pass === '') {
            setError('Error: Password is empty!');
            return;
        }
        try {
            const info = {
                email: email,
                password: pass
            }

            await axios.post(serverURL + '/accounts/login', info)
                .then((res) => {
                    if (res.data.errMessage) return setError('Error: ' + res.data.errMessage);

                    let x = res.data;
                    userContext.setUser(x.id, x.token, x.userName, x.email, x.rooms, x.friends);

                    Cookies.set('token', res.data.token,
                        {
                            expires: 7,
                            sameSite: "None",
                            secure: true
                        });
                    nav("/home");
                })
        } catch (err) {
            alert(err.message);
        }
    }

    // useEffect(() => {
    //     setModInfo(['Logging In...', 'Please wait while we log you in!']);
    //     $("#exampleModal").modal('toggle');
    // }, []);

    return (<>
        {/* <Modal title={modInfo[0]} body={modInfo[1]} /> */}
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-4 col-md-8 col-xs-12 mx-auto marTop">
                    <h2 className="center">Welcome to my project!</h2>
                    <p className="center">Please check out the credits page for more details and credits for the icons used!</p>
                    <div className="formContainer">
                        <form>
                            <h1>Login</h1><br />
                            <label><b>Email</b></label>
                            <input
                                type="text"
                                placeholder='Enter Email'
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                            />

                            <label><b>Password</b></label>
                            <input
                                type="password"
                                placeholder='Enter Password'
                                onChange={(e) => setPass(e.target.value)}
                                value={pass}
                            />

                            <p className="errorMessage">{error}</p>
                            <div className="formButtonContainer">
                                <button type="button" className="chatNavButton" onClick={onSubmit}>Login</button>
                            </div>
                            <div className="formButtonContainer">
                                <button type="button" className="chatNavButton cancel" onClick={() => { nav('/createAccount') }}>Create Account</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </>);

}

export default LogInPage;